/** @jsx h */
import { defineComponent, h, onMounted, onUnmounted } from "vue";

import { bc } from "../../../utils/boot";
import imageURL from "../../../images/escher/circle-limit.svg?url";

export const UnbootedLayout = defineComponent({
  name: "UnbootedLayout",
  setup() {
    const handler = (e: MessageEvent) => {
      const el = document.querySelector(".boot-message-log") as HTMLElement;
      if (el && e?.data) {
        el.innerHTML = e.data.message || "&nbsp;";
        if (e.data.type === "booted") {
          bc.removeEventListener("message", handler);
        }
      }
    };

    onMounted(() => {
      bc.addEventListener("message", handler);
    });

    onUnmounted(() => {
      bc.removeEventListener("message", handler);
    });

    return () => (
      <div class="h-screen w-screen flex flex-col justify-center items-center">
        <img class="border rounded glossy-bg hidden" src={imageURL} />
        <div style="margin: 10px auto;">...</div>
        <span style="font-size: 24px;" class="boot-message-log">
          loading
        </span>
      </div>
    );
  },
});
